'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';


interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const primaryNavItems = [
  { label: 'Home', href: '/homepage', icon: 'HomeIcon' },
  { label: 'Fabrication', href: '/fabrication-center', icon: 'CubeIcon' },
  { label: 'Welding', href: '/welding-excellence', icon: 'FireIcon' },
  { label: 'Assembly', href: '/assembly-excellence', icon: 'WrenchScrewdriverIcon' },
  { label: 'Coating', href: '/powder-coating-mastery', icon: 'SparklesIcon' }];


  const secondaryNavItems = [
  { label: 'Semiconductor', href: '/global-semiconductor-solutions', icon: 'CpuChipIcon' },
  { label: 'Quality & ISO', href: '/quality-iso-hub', icon: 'ShieldCheckIcon' },
  { label: 'Smart Quote', href: '/smart-quote-portal', icon: 'DocumentTextIcon' },
  { label: 'Quote Tracker', href: '/quote-status-tracker', icon: 'ClipboardDocumentListIcon' },
  { label: 'Quote Management', href: '/quote-management-dashboard', icon: 'ChartBarSquareIcon' },
  { label: 'Analytics', href: '/analytics-dashboard', icon: 'PresentationChartLineIcon' },
  { label: 'Portfolio', href: '/project-portfolio', icon: 'BriefcaseIcon' },
  { label: 'Contact', href: '/contact-hub', icon: 'PhoneIcon' }];


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsMoreMenuOpen(false);
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-card shadow-md ${className}`}>
      <div className="flex items-center justify-between h-16 px-4 lg:px-8">
        <Link href="/homepage" className="flex items-center space-x-3 flex-shrink-0">
          <Image
            src="/assets/images/FFC_logo_1-1769757377340.png"
            alt="Fusion Finishing Company Logo"
            width={30}
            height={28}
            className="object-contain" />

          <div className="flex flex-col">
            <span suppressHydrationWarning className="text-lg font-headline font-bold leading-tight">Fusion Finishing Co.
            </span>
            <span suppressHydrationWarning className="text-xs leading-tight text-[rgba(0,0,0,0.8)]">dba FFC PRODUCTION TRADE CO.
            </span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center space-x-1 flex-1 justify-center">
          {primaryNavItems.map((item) =>
          <Link
            key={item.href}
            href={item.href}
            className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-cta font-semibold text-foreground hover:bg-muted hover:text-primary transition-all duration-base">

              <Icon name={item.icon as any} size={20} variant="outline" />
              <span>{item.label}</span>
            </Link>
          )}

          <div className="relative">
            <button
              onClick={toggleMoreMenu}
              className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-cta font-semibold text-foreground hover:bg-muted hover:text-primary transition-all duration-base">

              <Icon name="EllipsisHorizontalIcon" size={20} variant="outline" />
              <span>More</span>
              <Icon
                name="ChevronDownIcon"
                size={16}
                variant="outline"
                className={`transform transition-transform duration-base ${
                isMoreMenuOpen ? 'rotate-180' : ''}`
                } />

            </button>

            {isMoreMenuOpen &&
            <div className="absolute top-full right-0 mt-2 w-56 bg-card shadow-lg rounded-md border border-border overflow-hidden">
                {secondaryNavItems.map((item) =>
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setIsMoreMenuOpen(false)}
                className="flex items-center space-x-3 px-4 py-3 text-sm font-body text-foreground hover:bg-muted hover:text-primary transition-all duration-base">

                    <Icon name={item.icon as any} size={20} variant="outline" />
                    <span>{item.label}</span>
                  </Link>
              )}
              </div>
            }
          </div>
        </nav>

        <div className="hidden lg:flex items-center space-x-3">
          <Link
            href="/smart-quote-portal"
            className="px-5 py-2.5 bg-conversion text-conversion-foreground rounded-md text-sm font-cta font-bold hover:opacity-90 transition-all duration-base shadow-sm">

            Get Quote
          </Link>
        </div>

        <button
          onClick={toggleMobileMenu}
          className="lg:hidden p-2 rounded-md text-foreground hover:bg-muted transition-all duration-base"
          aria-label="Toggle mobile menu">

          <Icon
            name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
            size={24}
            variant="outline" />

        </button>
      </div>

      {isMobileMenuOpen &&
      <div className="lg:hidden bg-card border-t border-border">
          <nav className="flex flex-col py-4">
            {[...primaryNavItems, ...secondaryNavItems].map((item) =>
          <Link
            key={item.href}
            href={item.href}
            onClick={() => setIsMobileMenuOpen(false)}
            className="flex items-center space-x-3 px-6 py-3 text-sm font-body text-foreground hover:bg-muted hover:text-primary transition-all duration-base">

                <Icon name={item.icon as any} size={20} variant="outline" />
                <span>{item.label}</span>
              </Link>
          )}

            <div className="px-6 pt-4 pb-2">
              <Link
              href="/smart-quote-portal"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full px-5 py-2.5 bg-conversion text-conversion-foreground rounded-md text-sm font-cta font-bold text-center hover:opacity-90 transition-all duration-base shadow-sm">

                Get Quote
              </Link>
            </div>
          </nav>
        </div>
      }
    </header>);

};

export default Header;